export default {
  'menu.home': 'En la primera página',
  'menu.chiselDetail': 'Cincel ',
  'menu.otherParts': 'Otras piezas',
  'menu.prodTech': 'Proceso de producción',
  'menu.service': 'Servicios',
  'menu.aboutUs': 'Acerca de nosotros',
  'menu.exhibitionDetail': 'Detalles de exposición'
}
